module.exports = __webpack_public_path__ + "093ee89be9ede30383f39a899c485a82.ttf";